export const ANNUAL = "annual";
export const MONTHLY = "monthly";
export const PLAN_TYPES = [ANNUAL, MONTHLY];

export const RIGHT = "right";
export const LEFT = "left";
export const ALIGNMENT_TYPES = [RIGHT, LEFT];

export const FREE_TIER = "free";
export const TEACHER_TIER = "a_plus_teacher";
export const A_PLUS_TIER = "a_plus";
export const PLAN_SUBSCRIPTION_TYPES = [FREE_TIER, A_PLUS_TIER, TEACHER_TIER];
